import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const AuthorTalks = () => <EventCategoryPage config={EVENT_CATEGORIES['author-talks']} data-id="element-9842" data-mp="1ko02ywhrq37h" />;
export default AuthorTalks;